import style from "../style/layout.module.css";

import { Card } from "../components/";
import React from "react";

export default function GameBody({ gameData, startGame, result }) {
  return (
    <div className={style.select_wrap}>
      <h4 className={style.select_title}>
        마음에 드시는 분을
        <br /> 선택해주세요
      </h4>
      <div className={style.select_card}>
        {gameData?.map((list) => (
          <React.Fragment key={list.name}>
            <div className={style.select_link} key={list.name}>
              <Card list={list} result={result} startGame={startGame} />
            </div>
            {gameData[0] === list && (
              <div className={style.vs}>
                <img src="/worldcup/imgs/vs.png" alt="vs" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
